module.exports = __webpack_public_path__ + "static/media/south-sudan.c05dcec9.png";